export default __webpack_public_path__ + "static/media/neutral-face.f8c76c33.png";